// extracted by mini-css-extract-plugin
export default {"container":"styles_container__xkJAz","background":"styles_background__l+zFH","squares":"styles_squares__4HpKD"};